export function initialize(appInstance) {
  // let socket = appInstance.lookup("service:socket")
  // socket.connect()
}

export default {
  name: "socket",
  initialize: initialize,
  before: ["store"],
  after: ["session"],
}
